<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">Deleted Category</h1>
          </div>
          <div class="col-sm-2">
            <router-link class="btn btn-primary" :to="{ name: 'all-categories' }">Back</router-link>
          </div>
        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">

            <div v-if="categories.length > 0">
              <MyTable :columns="columns" :actions="true">
                <tr v-for="(category, index) in filteredCategories" :key="index">
                  <th scope="row">{{ category.id }}</th>
                  <td>{{ category.name_ar }}</td>
                  <td>{{ category.name_en }}</td>
                  <td>
                    <img :src="category.main_image" width="50" height="50" class="img-thumbnail" />
                  </td>

                  <!-- <td><img :src="`${assets}service.image`"></td> -->
                  <td>
                    <button class="me-2 btn btn-success" @click="restoreCategory(category.id)">
                      Restore
                    </button>
                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No deleted categories found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import axios from "../../Axios";
import $ from 'jquery'; // Import jQuery
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component
export default {
  name: "DeletedCategories",
  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      dataTable: [], // Store DataTable instance
      categories: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Name Arabic', key: 'name_ar' },
        { label: 'Name English', key: 'name_en' },
        { label: 'Image', key: 'main_image' },
      ],
    };
  },

  async created() {
    this.fetchCategories();
  },

  computed: {
    filteredCategories() {
      if (!this.searchTerm) {
        return this.categories;
      }
      const term = this.searchTerm.toLowerCase();
      return this.categories.filter(
        (category) =>
          category.name.toLowerCase().includes(term) ||
          category.postal_code.toLowerCase().includes(term)
      );
    },
  },

  methods: {
    // fetch orders
    async fetchCategories() {
      try {
        const response = await axios.get(
          `/admin/admin/category/get-delete-soft`
        );
        this.categories = response.data.data;
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        // Ensure the DataTable is initialized only after the DOM is updated
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    restoreCategory(id) {
      axios
        .post(`/admin/admin/category/restore?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchCategories();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

};
</script>
<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>
